var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1183 3.024L10.2611 0.166841C10.2079 0.113504 10.1446 0.0713504 10.0748 0.0428571C10.0059 0.0146986 9.93217 0.000133928 9.85771 0H2.42913C1.48235 0 0.714844 0.767511 0.714844 1.71428V14.2857C0.714844 15.2325 1.48235 16 2.42913 16H11.572C12.5188 16 13.2863 15.2325 13.2863 14.2857V3.42857C13.2855 3.2769 13.2251 3.13162 13.1183 3.024ZM10.4291 1.95087L11.3354 2.85716H10.4291V1.95087ZM12.1434 14.2857C12.1434 14.6013 11.8876 14.8572 11.572 14.8572H2.42913C2.11353 14.8572 1.85769 14.6013 1.85769 14.2857V1.71428C1.85769 1.39868 2.11353 1.14285 2.42913 1.14285H9.28627V3.42857C9.28627 3.74417 9.5421 4.00001 9.85771 4.00001H12.1434V14.2857H12.1434Z",
    fill: "#5B6880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.96e091e28035b365b3245d7bce896fe0.svg";
export { ForwardRef as ReactComponent };